export const SET_COMPANY_DATA = 'AUTH/SET_COMPANY_DATA'
export const SET_COMPANY_DATA_LOADED = 'AUTH/SET_COMPANY_DATA_LOADED'
export const SET_USER = 'AUTH/SET_USER'
export const SET_USER_DATA = 'AUTH/SET_USER_DATA'
export const SET_TOKEN = 'AUTH/SET_TOKEN'